export enum FileStatus {
    Processing = 1,
    Uploading = 2,
    Scanning = 3,
    Accepted = 4,
    Rejected = 5,
    Failed = 6
};